import { memo } from 'react';
import styled from 'styled-components';

import theme from '@styles/theme';
import { HeaderType } from '@utils/types';
import NO_IMAGE from '@assets/images/empty.png';

import * as E from '@pages/Equipment/Equipment.style';
import { FlexBox, RegularFont } from '@components/styled/StyledComponents';
import { TableCell } from '@components/share/Table/table.style';
import StyledDnDList from '@components/styled/StyledDnDList';

type PlaylistRowProps = {
    index: number;
    header: HeaderType[];
    data: any;
    moveList: (id: number, to: number) => void;
    findList: (id: number) => { list: any; index: number };
    imgAspect: number;
};
const PlaylistRow = ({
    index,
    header = [],
    data,
    moveList,
    findList,
    imgAspect
}: PlaylistRowProps) => {
    return (
        <StyledDnDList
            id={data?.id as number}
            index={index}
            moveList={moveList}
            findList={findList}
            handlerMinWidth={header[0].minWidth}
            handlerWidth={header[0].width as number}
            ARROW
        >
            {data.notice ? (
                <TableCell
                    $minWidth={header[1].minWidth}
                    $width={header[1].width}
                >
                    <E.NoticeContent>{data?.notice || '-'}</E.NoticeContent>
                </TableCell>
            ) : (
                <TableCell
                    $minWidth={header[1].minWidth}
                    $width={header[1].width}
                >
                    <FlexBox $gap={20}>
                        <E.Thumbnail
                            src={`${data?.img}/${
                                (imgAspect as number) > 1 ? 68 : 36
                            }/${(imgAspect as number) >= 1 ? 36 : 68}`}
                            onError={(
                                e: React.SyntheticEvent<HTMLImageElement, Event>
                            ) => {
                                e.currentTarget.src = NO_IMAGE;
                            }}
                            alt="썸네일"
                            $width={imgAspect > 1 ? 68 : 36}
                            $height={imgAspect >= 1 ? 36 : 68}
                        />
                        <FileName>{data?.filename || '-'}</FileName>
                    </FlexBox>
                </TableCell>
            )}
            <TableCell
                $minWidth={header[2].minWidth}
                $width={header[2].width}
                $fontColor={theme.colors.deepGrayFontColor}
            >
                {data.filesize || '-'}
            </TableCell>
            <TableCell
                $minWidth={header[3].minWidth}
                $width={header[3].width}
                $fontColor={theme.colors.deepGrayFontColor}
            >
                {data.type || '-'}
            </TableCell>
        </StyledDnDList>
    );
};

export default memo(PlaylistRow);

const FileName = styled(RegularFont)`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
